import { Skeleton } from 'app/javascript/components/ui/skeleton';

// Skeleton for the storefront while the catalog is being fetched. Mirrors the
// header + one product section so the layout doesn't jump when products arrive.
export default function StoreLoading() {
  return (
    <div className="min-h-screen bg-background text-foreground" aria-busy="true" aria-label="Carregando loja">
      <div className="border-b border-border/40">
        <div className="mx-auto flex max-w-5xl items-center gap-4 px-4 py-8 sm:px-6">
          <Skeleton className="size-16 rounded-2xl" />
          <div className="space-y-2">
            <Skeleton className="h-7 w-48" />
            <Skeleton className="h-4 w-64" />
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6 sm:py-16">
        <Skeleton className="mb-6 h-9 w-40" />
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {Array.from({ length: 4 }).map((_, index) => (
            <div
              key={index}
              className="flex flex-col overflow-hidden rounded-2xl border border-slate-700/50 bg-slate-800/50"
            >
              <Skeleton className="aspect-square w-full rounded-none" />
              <div className="space-y-3 p-4">
                <Skeleton className="h-5 w-3/4" />
                <Skeleton className="h-9 w-full" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
